<div class="page-wrapper">
  <app-login-header *ngIf="showHeader" [showUserInfo]="showUserInfo"></app-login-header>

  <main
    class="page-content"
    [style.padding-top.px]="showHeader ? 30 : 0"
    [style.background-image]="bgImageUrl">
    <router-outlet></router-outlet>
  </main>

  <app-login-footer></app-login-footer>
</div>